import { create } from "zustand";

type ShellRevealPhase = "idle" | "holding" | "revealing";

interface ShellRevealStore {
  phase: ShellRevealPhase;
  setPhase: (phase: ShellRevealPhase) => void;
}

export const useShellRevealStore = create<ShellRevealStore>()(set => ({
  phase: "idle",
  setPhase: phase => set({ phase }),
}));
